import {
  Card,
  Flex,
  SimpleGrid,
  Spinner,
  Heading,
  HStack,
} from "@chakra-ui/react";
import {
  useGetMediaSurveysDataMutation,
  // useGetRawMediaSurveysDataMutation,
  useGetDisneyDataMutation,
  useCompareInterestsMutation,
  useGetMediaCommentsQuery,
} from "../../../store/services/mediaApi";
import { useParams } from "react-router";
import { NProgress } from "@saas-ui/react";

import { useEffect, useMemo, useRef, useState } from "react";

import QuestionDisplay from "../../surveys/QuestionDisplay.js";
import SurveyFilter from "../../surveys/SurveyFilter.js";
import { ExportPowerPointButton } from "../../surveys/powerpoint.js";
import { ComparePowerPointButton } from "../compare/Powerpoint.js";
// import { FiFileMinus, FiFileText } from "react-icons/fi";
import { DownloadCsvButton } from "../../surveys/DownloadSurveyData.js";

const Surveys = ({ mediaItemData }) => {
  const { id, client } = useParams();
  const [querySurveys, { data, isLoading, isError }] =
    useGetMediaSurveysDataMutation();
  const [queryGetDisneyData, { data: pptData, isLoading: pptLoading, error }] =
    useGetDisneyDataMutation();
  const { data: summaryData, isLoading: commentLoading } =
    useGetMediaCommentsQuery(id);
  const [postInterests, res] = useCompareInterestsMutation();


  const sortedData = useMemo(() => {
    if (!data) return

    return (data || []).map(item => ({
      ...item,
      data:
        item.question_type === 'multiple_choice'
          ? item.data.slice().sort((a, b) => b.value - a.value)
          : item.data,
    }))
  }, [data])

  // const [getRawData, rawData] = useGetRawMediaSurveysDataMutation();
  const [mediaMetaData, setMediaMetaData] = useState(null);
  const [surveyData, setSurveyData] = useState([]);
  // const [isExporting, setIsExporting] = useState(false);
  // const [topX, setTopX] = useState(1); // 0 = show all
  const [rank, setRank] = useState({ type: "top", count: 1 });
  const chartRefs = useRef([]);
  // Reset refs on each render so callback refs repopulate correctly
  chartRefs.current = [];

  useEffect(() => {
    const getData = async () => {
      if (!id || data || isLoading || isError) return;
      const storedFilters = localStorage.getItem(`surveyFilters-${id}`);
      const filters = storedFilters ? JSON.parse(storedFilters) : [];
      await querySurveys({ id, filters });
    };

    getData();
  }, [querySurveys, id, data, isLoading, isError]);

  useEffect(() => {
    if (surveyData.length === 0 && data) {
      setSurveyData(data);
    }
  }, [data]);

  useEffect(() => {
    if (client === "21" && mediaItemData?.media_items?.length > 0) {
      const mediaItem = mediaItemData.media_items.find(
        (n) => n.media_item_id === Number(id)
      );

      if (!mediaItem) {
        return;
      }

      const media_item_meta = {
        title: mediaItemData.title,
        release_date: mediaItemData.release_date,
        date_added: mediaItemData.date_added,
        media_type_id: mediaItem?.media_type_id,
        poster_url: mediaItemData.posters?.[0],
        media_item_id: mediaItem?.media_item_id,
        media_id: mediaItemData.media_id,
        client_id: client,
        subtitle: mediaItem?.subtitle,
        mime_type_1: mediaItem?.mime_type_1,
        mime_type_2: mediaItem?.mime_type_2,
        order_num: mediaItem?.order_num,
        active: mediaItem?.active,
      };

      setMediaMetaData({
        media_items: [Number(id)],
        media_item_meta: [media_item_meta],
      });
    }
  }, [client, id, mediaItemData]);

  const top2BoxData = useMemo(() => {
    if (client !== '2') return [];

    if (!data || data?.length === 0) return [];

    return data
      .filter((item) =>
        item.question.startsWith(
          'How interested are you in seeing more stories that'
        )
      )
      .map((item) => {
        const total = item.data.reduce((sum, d) => {
          if (d.answer_id === 'more' || d.answer_id === 'same') {
            return sum + (d.value || 0);
          }
          return sum;
        }, 0);

        const parts = item.question.split('that');
        const label = parts.length > 1 ? parts.pop().trim() : item.question;

        const name =
          label.length > 0
            ? label[0].toUpperCase() + label.slice(1)
            : item.question;

        return {
          name,
          value: parseFloat((total).toFixed(1)),
        };
      })
      .sort((a, b) => b.value - a.value);
  }, [data, client]);

  const top2CharacterData = useMemo(() => {
    if (client !== '2') return [];

    if (!data || data?.length === 0) return [];

    return data
      .filter((item) =>
        item.question.startsWith(
          'Please rate the character'
        )
      )
      .map((item) => {
        const total = item.data.reduce((sum, d) => {
          if (d.answer_id === '5 - Excellent' || d.answer_id === '4 - Very Good') {
            return sum + (d.value || 0);
          }
          return sum;
        }, 0);

        const str = item.question;
        const match = str.match(/Please rate the character\s+([^(]+)/i);
        const characterName = match ? match[1].trim() : '';

        return {
          name: characterName,
          value: parseFloat((total).toFixed(1)),
        };
      }).sort((a, b) => b.value - a.value);
  }, [data, client]);

  const top2relationshipData = useMemo(() => {
    if (client !== '2') return [];

    if (!data || data?.length === 0) return [];

    return data
      .filter((item) =>
        item.question.startsWith(
          'How much did you enjoy the relationship'
        )
      )
      .map((item) => {
        const total = item.data.reduce((sum, d) => {
          if (d.answer_id === 'Very' || d.answer_id === 'Somewhat') {
            return sum + (d.value || 0);
          }
          return sum;
        }, 0);

        const str = item.question;
        const match = str.match(/How much did you enjoy the relationship between\s+([^(]+)/i);
        const characterName = match ? match[1].trim() : '';

        return {
          name: characterName,
          value: parseFloat((total).toFixed(1)),
        };
      }).sort((a, b) => b.value - a.value);
  }, [data, client]);

  useEffect(() => {
    if (mediaMetaData) {
      postInterests(mediaMetaData);
      queryGetDisneyData(mediaMetaData);
    }
  }, [mediaMetaData]);

  if (isLoading) {
    return (
      <Flex
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
      >
        <NProgress colorScheme="red" isAnimating position="absolute" />
        <Spinner size="lg" />
      </Flex>
    );
  }

  const getSumaryData = (summary) => {
    return [
      {
        media_item_id: id,
        media_title: pptData?.meta_data[0]?.title, // assuming you meant to use subtitle as title
        subtitle: pptData?.meta_data[0]?.subtitle,
        summary_content: summary,
        redirect_uri: `https://portal.volkno.com/${21}/media/${id}/overview`,
      },
    ];
  };

  return (
    <Flex width="100%" flexDirection="column">
      <HStack
        p="4"
        my="2"
        border="1px solid"
        borderColor="gray.200"
        bg="white"
        borderRadius="md"
        shadow="sm"
        justifyContent="space-between"
      >
        <Heading>{mediaItemData?.title} Surveys</Heading>

        <HStack>
          <DownloadCsvButton id={id} />
          {client === "21" ? (
            // <ComparePowerPointButton media_item_meta={mediaMetaData} />
            <ComparePowerPointButton
              media_item_meta={pptData?.meta_data}
              surveyData={surveyData}
              // selectedSurvey={selectedSurvey}
              pptData={pptData}
              interestDrivers={res?.data?.graph_data}
              mediaSummaries={getSumaryData(summaryData?.summary)}
              singleMedia={true}
            />
          ) : (
            <ExportPowerPointButton id={id} filters={surveyData} rank={rank} />
          )}
          {/* <Button
            onClick={async () => {
              setIsExporting(true);
              await exportPowerPointCharts(chartRefs, data);
              setIsExporting(false);
            }}
            leftIcon={<FiFileText />}
            isLoading={isExporting}
            loadingText="Exporting..."
          >
            Export to PowerPoint
          </Button> */}
        </HStack>
      </HStack>
      <SurveyFilter
        submit={querySurveys}
        id={id}
        isLoading={isLoading}
        data={surveyData}
        rank={rank}
        setRank={setRank}
      />
      <SimpleGrid columns={2} gap={5} mt={4}>
        {sortedData?.map((ithQuestion, idx) => (
          <Card
            key={`ithQuestion-${idx}`}
            p="3"
            height={"100%"}
            ref={(el) => (chartRefs.current[idx] = el)}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <QuestionDisplay
              data={ithQuestion?.data}
              question_type={ithQuestion?.question_type}
              question={ithQuestion?.question}
              rank={rank}
            />
          </Card>
        ))}
        {/* Update by Warner Bros */}
        {client === '2' && (
          <>
            {[
              {
                data: top2BoxData,
                question: "How interested are you in seeing more stories:",
              },
              {
                data: top2CharacterData,
                question: "Character Rankings:",
              },
              {
                data: top2relationshipData,
                question: "Relationship Rankings:",
              },
            ]
              .filter(({ data }) => data?.length > 0)
              .map(({ data, question }, idx) => (
                <Card
                  key={question}
                  p="3"
                  height="100%"
                  // ref={(el) => (chartRefs.current[idx] = el)}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                  }}
                >
                  <QuestionDisplay
                    data={data}
                    question_type="multiple_choice"
                    question={question}
                    rank={rank}
                  />
                </Card>
              ))}
          </>
        )}
      </SimpleGrid>
    </Flex>
  );
};
export default Surveys;
